import * as account from './account/actions';
import * as app from './app/actions';

export const universalActions = { account, app };
